export const localIconNameList = [
    '4g',
    '5g',
    'accessories',
    'add',
    'added',
    'ai-robot',
    'airplay',
    'alarm',
    'alert',
    'arrow-down',
    'arrow-left',
    'arrow-right',
    'arrow-up',
    'backup',
    'bag',
    'basketball',
    'battery',
    'best-in-test',
    'blood-pressure',
    'boardband',
    'broadband',
    'bus',
    'business-intelligence',
    'buy',
    'calendar',
    'camera',
    'care',
    'cast',
    'chat',
    'check-bold',
    'checkmark',
    'chevron-double-left',
    'chevron-double-right',
    'chevron-down',
    'chevron-left',
    'chevron-right',
    'chevron-up',
    'circle-number-1',
    'circle-number-2',
    'circle-number-3',
    'clock',
    'close',
    'cloud-computing',
    'cloud-optimization',
    'cloud-smart-decisions',
    'cloud',
    'coffee',
    'connected-building',
    'contacts',
    'containers-on-cloud',
    'conversation',
    'customer-dialogue',
    'cyber-security-solutions',
    'data-center',
    'data-rollover-green',
    'data-rollover',
    'default-image',
    'delete-filled',
    'delete',
    'delivery',
    'desktop',
    'devices',
    'devops',
    'disney-logo-small',
    'doc',
    'download',
    'dsl-hub',
    'email',
    'end-user',
    'enterprise-equipment',
    'entertainment-film',
    'entertainment',
    'environment',
    'esim-simcard',
    'favourites',
    'fiber',
    'filter',
    'fire',
    'fixed-internet-failover',
    'fixed-voice',
    'folder',
    'fullscreen',
    'games',
    'getting-started',
    'gift',
    'graph',
    'guiding-light',
    'hbo-max-logo-small',
    'home',
    'homecare',
    'hosting',
    'imdb',
    'info-blue',
    'info-filled',
    'info',
    'internet-of-things-2',
    'internet-of-things',
    'internet',
    'invoice',
    'ipad',
    'jobsearch',
    'laptop',
    'letter',
    'lightning',
    'like',
    'link',
    'listen',
    'lock-closed',
    'login',
    'logout',
    'love',
    'managed-services',
    'map',
    'mask',
    'mbb',
    'megaphone',
    'menu',
    'microsoft-365',
    'mobile',
    'mobility-equipment',
    'mobility',
    'money-back',
    'money-krone',
    'money',
    'more',
    'multi-cloud-solutions',
    'music',
    'netflix-letter-logo-small',
    'network-lost',
    'network',
    'news',
    'notifications',
    'offering',
    'open-in-new',
    'open-security',
    'optimization',
    'org-chart',
    'parental-guide',
    'password-invisible',
    'password-visible',
    'pay-monthly',
    'pay-once',
    'payment',
    'pebble-logo',
    'people-hub',
    'people',
    'phone-broken',
    'phone-checkmark',
    'phone-ringing',
    'phone',
    'pie-chart',
    'plan-card-plus',
    'play',
    'player-settings',
    'plus-minus',
    'plus',
    'pod',
    'premises',
    'press-button',
    'questionmark-circled-filled',
    'recycle-phone',
    'recycle',
    'refill-card',
    'remote-control',
    'repair',
    'roaming',
    'router',
    'savings',
    'search',
    'secure',
    'secured',
    'security-on-cloud',
    'security',
    'sense-car',
    'server',
    'settings',
    'share',
    'shopping',
    'shuffle',
    'silent',
    'sim-blocked',
    'simcard',
    'skip-back-10sec',
    'skip-back-30sec',
    'skip-forward-10sec',
    'skip-forward-30sec',
    'slow-wifi',
    'smartwifi',
    'smiley-sad',
    'smiley',
    'snowflake',
    'statistics',
    'summary',
    'support',
    'sustainability',
    'switch',
    'sync',
    'telia-smart-connect',
    'telia-tv',
    'trailer',
    'trash-empty',
    'travel-abroad',
    'travel',
    'tv-next',
    'tv-pause',
    'tv-play',
    'tv-previous',
    'tv',
    'twitter',
    'usb',
    'video-conference',
    'video-survailance-solutions',
    'video',
    'volume',
    'wallet',
    'wallplug',
    'watch',
    'water-drop',
    'wholesale-internet',
    'wifi-mobile',
    'wireless',
    'work-place-management',
    'world',
];
